import { omit } from 'lodash-es';
import React from 'react';

import type { IconProps } from '#@/components/Icon';

import ClickableText from '../ClickableText';
import {
  TooltipAction,
  TooltipBodyText,
  TooltipIcon,
  TooltipSectionContainer,
  TooltipSectionContent,
  TooltipTitle,
} from './Styles';

export interface TooltipSectionProps {
  title?: React.ReactNode;
  bodyText?: React.ReactNode;
  /** @deprecated Use `actions` prop instead */
  actionText?: string;
  /** @deprecated Use `actions` prop instead */
  action?: () => void;
  actions?: {
    text: string;
    action?: () => void;
    props?: Record<string, unknown>;
  }[];
  closeTooltip: () => void;
  icon?: IconProps;
}

const TooltipSection: React.FC<TooltipSectionProps> = ({
  title,
  bodyText,
  actionText,
  action,
  actions: providedActions,
  closeTooltip,
  icon,
}) => {
  const actions = [];
  if (actionText) {
    actions.push({ text: actionText, action });
  }
  if (providedActions) {
    actions.push(...providedActions);
  }

  return (
    <TooltipSectionContainer>
      {icon && <TooltipIcon {...omit(icon, 'size')} />}
      {(title || bodyText || actionText) && (
        <TooltipSectionContent>
          {title && <TooltipTitle $isWithIcon={Boolean(icon)}>{title}</TooltipTitle>}
          {bodyText && <TooltipBodyText>{bodyText}</TooltipBodyText>}
          {actions.map(({ text, action: actionFn, props: actionProps = {} }) => (
            <TooltipAction
              key={text}
              onClick={() => {
                closeTooltip();
                if (actionFn) actionFn();
              }}
            >
              <ClickableText {...actionProps}>{text}</ClickableText>
            </TooltipAction>
          ))}
        </TooltipSectionContent>
      )}
    </TooltipSectionContainer>
  );
};

export default TooltipSection;
